import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { ContactListComponent } from '../contact-list/contact-list.component';
import { Subscription } from 'rxjs';
import { ContactModel } from 'src/app/core/models/contact/contact.model';
import { ContactBaseModel } from 'src/app/core/models/contact/contact-base.model';
import { EntityTypeEnum } from "src/app/core/enums/entity-type-id-enum";
import { DomSanitizer } from '@angular/platform-browser';
import { AuthMyfileService } from 'src/app/core/services/auth.myfile.service';
import { ContactListService } from 'src/app/core/services/list-services/contact-list.service';
import { OpenModalService } from 'src/app/core/services/modal-services/open-modal.service';
import { PdfViewerModalService } from 'src/app/core/services/modal-services/pdf-viewer-modal.service';
import { MyfileApiService } from 'src/app/core/services/myfile-api.service';
import { ToasterNotificationService } from 'src/app/core/services/toaster-notification.service';
import { TaskModalService } from 'src/app/core/services/modal-services/task-modal.service';
import { ActionIdEnum } from 'src/app/core/enums/list-layout/action-id-enum';
import { TableActionsModel } from 'src/app/core/models/table/table-action.model';
import { ContactPickListTableConfig } from './contact-picklist.config';
import { TableConfigService } from 'src/app/core/services/table-config.service';
import { GlobalComponent } from 'src/app/global-component';

@Component({
  selector: 'app-contact-picklist',
  templateUrl: './contact-picklist.component.html',
  styleUrls: ['./contact-picklist.component.scss']
})
export class ContactPicklistComponent extends ContactListComponent {

  selectedModelIdFromCheckedList: string = "";

  @Input() public referenceModel: ContactModel = new ContactModel();

  @Output() referenceModelChange = new EventEmitter<any>();

  constructor(
    protected changeDetectorRef: ChangeDetectorRef,
    protected override taskModalService: TaskModalService,
    protected override contactListService: ContactListService,
    protected override toasterNotificationService: ToasterNotificationService,
    protected override tableConfigService: TableConfigService,
    protected override myFileApiService: MyfileApiService,
    protected override sanitizer: DomSanitizer,
    protected override openModalService: OpenModalService,
    protected override pdfModalService: PdfViewerModalService,
    protected override authMyFileService: AuthMyfileService,
  ) {
    super(taskModalService, contactListService, tableConfigService, myFileApiService, sanitizer, pdfModalService, authMyFileService, toasterNotificationService, openModalService);
  }

  override ngOnInit(): void {

    this.tableConfig = new ContactPickListTableConfig();

    this.configItemsObservable = this.tableConfigService.resultItems$;
    const subscrConfig = this.configItemsObservable.subscribe(result => {
      if (result && result[0]) {
        //needed to be able to avoid null from the model when its decoded. 
        this.tableConfig = JSON.parse(JSON.stringify(result[0], (key, value) => {
          if (value !== null) return value;
        }));
        if (this.tableConfig.pageSize !== GlobalComponent.defaultPagingInfo.pageSize) {
          this.contactListService.pageSize = this.tableConfig.pageSize;
        }
      }
    });
    this.unsubscribe.push(subscrConfig);

    this.tableConfigService.createdById = this.authMyFileService.currentUserContextValue?.id;
    this.tableConfigService.listTitle = this.tableConfig.listTitle!;

    this.listItemsObservable = this.contactListService.resultItems$;
    this.total = this.contactListService.total$;
    this.isLoading = this.contactListService.loading$;

    const subscr = this.isLoading.subscribe(result => {
      if (result) {
        this.serviceData.loadingValue = true;
      } else {
        this.serviceData.loadingValue = false;
      }
    });
    this.unsubscribe.push(subscr);

    const subscr2 = this.listItemsObservable.subscribe(result => {
      this.listItems = Object.assign([], result);
      this.listItems.forEach((contactModel: ContactBaseModel) => {
        this.getEntityPhoto(contactModel, EntityTypeEnum.Account);
      });
    });
    this.unsubscribe.push(subscr2);

    const subscr3 = this.total.subscribe(result => {
      this.serviceData.totalRecords = this.contactListService.totalRecords;
      this.serviceData.pageSize = this.contactListService.pageSize;
      this.serviceData.pageIndex = this.contactListService.pageIndex;
    });
    this.unsubscribe.push(subscr3);
  }

  selectContacts() {
    this.submitted = true;
    this.selectedModelIdFromCheckedList = "";
    this.checkedValGet.forEach((model: any) => {
      if (model.id) {
        this.selectedModelIdFromCheckedList = model.id;
      }
    })
    this.selectContact(this.selectedModelIdFromCheckedList);
  }

  selectContact(contactId: string) {
    this.submitted = true
    if (contactId !== undefined && contactId !== null && contactId.length > 0) {
      var sub: Subscription = this.myFileApiService.getContact(contactId)
        .subscribe((contact: ContactModel) => {
          if (contact) {
            this.model = contact;
            this.legacyContactInfoCheckAndSet();
            this.referenceModel = this.model;
            this.referenceModelChange.emit(this.referenceModel);
          }
          this.submitted = false;
          sub.unsubscribe();
        });
    } else {
      this.submitted = false;
    }
  }

  override rowActionSelected(rowAction: TableActionsModel) {
    switch (rowAction.actionIdSelected) {
      case ActionIdEnum.Edit:
        if (rowAction.model == undefined || rowAction.model.id == undefined) {
          this.toasterNotificationService.showError($localize`:@@Toast_Error_GeneralText:Something went wrong. Please try again later.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
          return;
        }
        this.openModalService.editContactModal(this.contactListService, rowAction.model.id, undefined, undefined);
        break;
      case ActionIdEnum.OpenModal:
        if (rowAction.model == undefined || rowAction.model.id == undefined) {
          this.toasterNotificationService.showError($localize`:@@Toast_Error_GeneralText:Something went wrong. Please try again later.`, $localize`:@@Toast_Error_GeneralTitle:Error`);
          return;
        }
        this.openModalService.openContactModal(rowAction.model, this.contactListService, undefined, undefined);
        break;
      case ActionIdEnum.View:
        if (rowAction.model != undefined && rowAction.model.id != undefined) {
          this.sideProfileView(rowAction.model.id)
        }
        break;
      case ActionIdEnum.Select:
        if (rowAction.model != undefined && rowAction.model.id != undefined) {
          this.selectContact(rowAction.model.id);
        }
        break;
    }
  }

}
